import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const MagicWand = withDefaultIconProps({ height: 32, width: 32 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 32 32" fill="none">
    <Path
      d="M24.42 15.35L15.35 6.28C14.99 5.92 14.41 5.92 14.06 6.28C13.7 6.64 13.7 7.22 14.06 7.57L14.82 8.34L4.42 23.71C4.18 24.07 4.22 24.56 4.54 24.87L7.13 27.46C7.44 27.78 7.93 27.82 8.29 27.58L10.71 25.94C11.57 27.05 12.91 27.73 14.35 27.73C16.88 27.73 18.93 25.68 18.93 23.15C18.93 22.31 18.71 21.51 18.3 20.81L23.67 17.18L24.43 17.94C24.78 18.3 25.37 18.3 25.72 17.94C26.08 17.59 26.08 17.01 25.72 16.65L24.42 15.35ZM7.89 25.63L6.37 24.11L14.05 12.75L19.25 17.95C7.91 25.62 8.1 25.49 7.89 25.63ZM17.1 23.15C17.1 24.67 15.87 25.9 14.35 25.9C13.52 25.9 12.75 25.53 12.24 24.91L16.77 21.84C16.99 22.24 17.1 22.69 17.1 23.15ZM20.8 16.91L15.09 11.2L16.14 9.66L22.34 15.86L20.8 16.91Z"
      fill={color}
    />
    <Path
      d="M22.93 10.37L25.52 7.78C25.88 7.42 25.88 6.84 25.52 6.48C25.16 6.12 24.58 6.12 24.22 6.48L21.63 9.07C21.27 9.43 21.27 10.01 21.63 10.37C21.99 10.73 22.57 10.73 22.93 10.37Z"
      fill={color}
    />
    <Path
      d="M19.4 8C19.88 8.16 20.4 7.9 20.56 7.42L21.21 5.47C21.37 4.99 21.11 4.47 20.63 4.31C20.15 4.15 19.63 4.41 19.47 4.89L18.82 6.84C18.66 7.32 18.92 7.84 19.4 8Z"
      fill={color}
    />
    <Path
      d="M27.69 11.38C27.53 10.9 27.01 10.64 26.53 10.8L24.58 11.44C24.1 11.6 23.84 12.12 24 12.6C24.16 13.08 24.68 13.34 25.16 13.18L27.11 12.53C27.59 12.37 27.85 11.86 27.69 11.38Z"
      fill={color}
    />
  </Svg>
));
